<template>
  <div class="edit_test_config">
    <h4 class="title">
      {{ translate("device_models.modal_header", {device_sku: device_sku}) }}
    </h4>

    <codemirror
        class="codemirror card"
        v-model="config"
        :options="{
            mode: 'toml',
            theme: 'neat',
            lineNumbers: true,
            tabSize: 2
          }"
    />

    <div class="text-center">
      <span
          v-if="test_config !== config"
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="update_test_config"
      >
        {{ translate("btn.edit") }}
      </span>

      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate("btn.close") }}
      </span>
    </div>
  </div>

</template>
<script>

export default {
  name: "EditTestConfig",
  props: [
    "id",
    "test_config",
    "device_sku"
  ],

  data () {
    return {
      config: ""
    }
  },
  created() {
    this.config = this.test_config
  },
  methods: {
    update_test_config(){
      this.$http.v1.putDeviceSku(this.id, {config: this.config}, (response) => {
        this.global_notify('info', this.translate('device_models.saved_success'))
        this.$emit('update', response.data)
      })
    },
    cancel () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss'>
  .edit_test_config{
    padding: 10px;
    .title{
      margin: 0 0 10px;
      text-align: center;
    }
    .codemirror{
      height: 500px;
    }
    pre{
      max-height: 500px
    }
  }

</style>
